export default "__VITE_ASSET__adfecb09__"